/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type SetOrganizationWhitelistRequestBody = {
  /**
   * The ID of the organization to update
   */
  organizationId: string;
  /**
   * Whether the organization should be whitelisted
   */
  whitelisted: boolean;
};

/** @internal */
export type SetOrganizationWhitelistRequestBody$Outbound = {
  organization_id: string;
  whitelisted: boolean;
};

/** @internal */
export const SetOrganizationWhitelistRequestBody$outboundSchema: z.ZodMiniType<
  SetOrganizationWhitelistRequestBody$Outbound,
  SetOrganizationWhitelistRequestBody
> = z.pipe(
  z.object({
    organizationId: z.string(),
    whitelisted: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      organizationId: "organization_id",
    });
  }),
);

export function setOrganizationWhitelistRequestBodyToJSON(
  setOrganizationWhitelistRequestBody: SetOrganizationWhitelistRequestBody,
): string {
  return JSON.stringify(
    SetOrganizationWhitelistRequestBody$outboundSchema.parse(
      setOrganizationWhitelistRequestBody,
    ),
  );
}
